import React, { useMemo } from "react"

import { useScreenSize } from "shared/lib/useScreenSize"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { ProductPositionTableRowWrapper } from "../../ProductPositionTableRowWrapper"
import { useProductPositionTableLoadingRowPayload } from "../../contexts/ProductPositionTableLoadingRowPayloadContext"
import { getProductPositionTableProductPositionColumnSizes } from "../../getProductPositionTableColumnSizes"

export interface LoadingProductPositionTableRowProps {
  index: number
}

export const LoadingProductPositionTableRow = React.memo(
  ({ index }: LoadingProductPositionTableRowProps) => {
    const {
      hideQuantity,
      showClarificationRequestColumn,
      showSelectionCheckbox,
      columnPreset
    } = useProductPositionTableLoadingRowPayload()
    const { isTablet } = useScreenSize()
    const isSelection = columnPreset === "selection"
    const style = useMemo(
      () => ({
        ...getProductPositionTableProductPositionColumnSizes({
          hideQuantity,
          hideVariantKey: isTablet,
          showClarificationRequestColumn,
          showSelectionCheckbox,
          columnPreset
        })
      }),
      [
        hideQuantity,
        isTablet,
        showClarificationRequestColumn,
        showSelectionCheckbox,
        columnPreset
      ]
    )

    return (
      <ProductPositionTableRowWrapper
        role="row"
        index={index}
        style={style}
        isLoading
      >
        <div aria-hidden className="table-row-cell loading left-space" />
        {showSelectionCheckbox ? (
          <div
            aria-hidden
            className="table-row-cell loading loading-selection-cell"
          />
        ) : null}
        <div
          role="gridcell"
          className="product table-row-cell collapse-button"
        />
        <div
          role="gridcell"
          className="position table-row-cell loading"
          data-testid="product-position-cell"
        >
          <Skeleton containerClassName="flex-grow-1" />
        </div>
        {showClarificationRequestColumn ? (
          <div
            role="gridcell"
            className="clarification-request table-row-cell loading"
          />
        ) : null}
        <div role="gridcell" className="product table-row-cell loading">
          <Skeleton containerClassName="flex-grow-1" />
        </div>
        {!isTablet ? (
          <div role="gridcell" className="key table-row-cell loading">
            <Skeleton containerClassName="flex-grow-1" />
          </div>
        ) : null}
        {isSelection || hideQuantity ? null : (
          <div role="gridcell" className="quantity table-row-cell loading">
            <Skeleton containerClassName="flex-grow-1" />
          </div>
        )}
        {isSelection ? null : (
          <div role="gridcell" className="icons table-row-cell loading">
            <Skeleton containerClassName="flex-grow-1" />
          </div>
        )}
        <div aria-hidden className="table-row-cell loading right-space" />
      </ProductPositionTableRowWrapper>
    )
  }
)
